export const CARDS_ROUTE_PATHS = {
  cards: '/cards',
  debitCardOperations: '/cards/debit-card-operations',
  affiliates: '/cards/affiliates',
  debitCardAbm: '/cards/debit-card-abm',
  productPack: '/cards/debit-card-product-pack',
};

export const CARDS_API_PATHS = {
  countryLimits: '/v1/api/platform/debit-card/limits/country',
  countryLimitDelete: '/v1/api/platform/debit-card/limits/country/:countryId/loyalty-level/:loyaltyLevel',
  userLimits: '/v1/api/platform/debit-card/limits/user/:userId',
  upsertUserLimits: '/v1/api/platform/debit-card/limits/user',
  deleteUserLimits: '/v1/api/platform/debit-card/limits/user/:userId',
  accountTransfer: '/v1/api/platform/debit-card/providers/account-transfer',
  cancelProviderAccount: '/v1/api/platform/debit-card/providers/user/:userId/provider/:providerId/account',
  chargebacks: '/v1/api/platform/debit-card/chargeback',
  chargebackCreate: '/v1/api/platform/debit-card/chargeback-create',
  chargebackBatchCreate: '/v1/api/platform/debit-card/batch/chargeback-create',
  chargebackEdit: '/v1/api/platform/debit-card/chargeback-edit',
  providerStockProviders: '/v1/api/platform/debit-card/providers/stocks/providers',
  providerStock: '/v1/api/platform/debit-card/providers/stocks/:providerId',
  providerRestock: '/v1/api/platform/debit-card/providers/stocks/restock',
  updateCardStatus: '/v1/api/platform/debit-card/csv/update-card-status',
  migrateCards: '/v1/api/platform/debit-card/csv/migrate-cards',
  providers: '/v1/api/platform/debit-card/providers',
  closeAccount: '/v1/api/platform/debit-card/providers/:providerId/close-account',
  manualClearUp: '/v1/api/platform/debit-card/operations/providers/:providerId/clear',
  manualApproval: '/v1/api/platform/debit-card/transaction/manual-approve',
  manualApprovalApprove: '/v1/api/platform/debit-card/transaction/manual-approval',
  manualApprovalReject: '/v1/api/platform/debit-card/transaction/manual-reject',
  massiveManualTrx: '/v1/api/platform/debit-card/support/manual-trx',
  massiveManualApproval: '/v1/api/platform/debit-card/support/transaction/manual-approval',
  affiliates: '/v1/api/platform/affiliates',
  affiliatesCommission: '/v1/api/platform/affiliates/commission',
  guestCodes: '/v1/api/platform/affiliates/guest-code',
  guestCodeCreate: '/v1/api/platform/affiliates/guest-code/create',
  guestCodeEdit: '/v1/api/platform/affiliates/guest-code/edit',
  referrers: '/v1/api/platform/affiliates/referrer',
  referrerCreate: '/v1/api/platform/affiliates/referrer/create',
  referrerEdit: '/v1/api/platform/affiliates/referrer/edit',
  referralRecover: '/v1/api/platform/affiliates/referral/recover',
  referralRecoverBatch: '/v1/api/platform/affiliates/referral/recover/batch',
  merchantRules: '/v1/api/platform/affiliates/merchant/rules',
  financePanelCombos: '/public/v1/api/finance-panel/combos',
  abmCountryMerchantBlacklist: '/v1/api/platform/debit-card/abm/country-merchant/blacklist',
  abmCountryMerchantBlacklistDelete: '/v1/api/platform/debit-card/abm/country-merchant/blacklist/:blackListId',
  abmMccBlacklist: '/v1/api/platform/debit-card/abm/mcc/blacklist',
  abmMccBlacklistDelete: '/v1/api/platform/debit-card/abm/mcc/blacklist/:blackListId',
};
